import { Cpu, Bot, BarChart3, Cloud, Database, ShieldCheck } from "lucide-react";

const items = [
  { icon: Cpu, title: "Custom Software Development", desc: "Web, mobile, and enterprise software built to your specifications." },
  { icon: Bot, title: "AI & Automation Solutions", desc: "Workflow automation, AI assistants, and intelligent process bots." },
  { icon: BarChart3, title: "Machine Learning & Analytics", desc: "Predictive models, data dashboards, and business intelligence tools." },
  { icon: Cloud, title: "Cloud & DevOps Services", desc: "Scalable cloud infrastructure on AWS, Azure, and GCP." },
  { icon: Database, title: "ERP & Digital Transformation", desc: "Streamline operations with ERP integration and process automation." },
  { icon: ShieldCheck, title: "Cybersecurity & Managed Services", desc: "Protect your business with enterprise-grade security solutions." },
];

export default function AIServices() {
  return (
    <section id="ai-services" className="py-20 lg:py-28 relative overflow-hidden" data-testid="ai-services-section">
      <div className="absolute inset-0 bee-grid-bg opacity-30 pointer-events-none" />
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl">
          <div className="text-xs uppercase tracking-[0.2em] text-bee-orange font-semibold mb-3">AI-Driven IT Services</div>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight leading-[1.05]">
            Beyond recruitment —{" "}
            <span className="text-bee-teal">we build the tech you need.</span>
          </h2>
          <p className="mt-5 text-base lg:text-lg text-muted-foreground">
            From custom software development to intelligent automation, we help businesses modernize their
            operations with cutting-edge AI services.
          </p>
        </div>

        <div className="mt-12 grid md:grid-cols-2 lg:grid-cols-3 gap-5">
          {items.map((s, i) => (
            <div
              key={s.title}
              data-testid={`ai-service-${i}`}
              className="group relative rounded-2xl border border-border bg-card p-6 card-lift overflow-hidden"
            >
              <div className="absolute -top-12 -right-12 h-32 w-32 rounded-full bg-bee-teal/5 group-hover:bg-bee-orange/10 transition-colors" />
              <div className="relative">
                <div className="h-12 w-12 rounded-xl bg-bee-teal text-white inline-flex items-center justify-center">
                  <s.icon className="h-5 w-5" />
                </div>
                <h3 className="mt-5 font-display text-xl font-bold tracking-tight">{s.title}</h3>
                <p className="mt-2 text-sm text-muted-foreground leading-relaxed">{s.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
